// extracted by mini-css-extract-plugin
export var layoutContainer = "_d8-0";
export var layoutContainerNoRounding = "_d8-6";
export var layoutContainerOpen = "_d8-5";
export var layoutContainerResizing = "_d8-1";
export var mainContent = "_d8-2";
export var resizeDivider = "_d8-3";
export var slidePanel = "_d8-4";